export enum EApiCallStateNames {
  CONVENTIONS = 'CONVENTIONS',
  CONTRACTS = 'CONTRACTS',
}

export enum EApiRequestPartKeys {
  SEARCH = 'SEARCH',
  PAGINATION = 'PAGINATION',
  FILTERS = 'FILTERS',
  SORTING = 'SORTING',
  NAME_AQ_CONVENTION_SORTING = 'NAME_AQ_CONVENTION_SORTING',
  SELLER_SORTING = 'SELLER_SORTING',
  CONVENTION_ACTIVATION_DATE_SORTING = 'CONVENTION_ACTIVATION_DATE_SORTING',
  CONVENTION_DURATION_IN_MONTHS_SORTING = 'CONVENTION_DURATION_IN_MONTHS_SORTING',
  RENEWAL_DURATION_IN_MOTHS_SORTING = 'RENEWAL_DURATION_IN_MOTHS_SORTING',
  CREATION_SORTING = 'CREATION_SORTING',
  CONTRACT_ID_SORTING = 'CONTRACT_ID_SORTING',
  CONTRACT_NAME_SORTING = 'CONTRACT_NAME_SORTING',
  BUSINESS_NAME_SORTING = 'BUSINESS_NAME_SORTING',
  CONTRACT_UPDATED_AT_SORTING = 'CONTRACT_UPDATED_AT_SORTING',
  CONTRACT_ENTRY_DATE_SORTING = 'CONTRACT_ENTRY_DATE_SORTING',
  STATE_SORTING = 'STATE_SORTING',
}
